export type HotkeyModifier = 'ctrl' | 'meta' | 'ctrl+meta' | 'shift' | 'alt'

export interface HotkeyConfig {
  key: string
  modifier?: HotkeyModifier
}

export const hotkeyMap = {
  openSearch: { key: 'k', modifier: 'ctrl+meta' },
} satisfies Record<string, HotkeyConfig>

export type HotkeyName = keyof typeof hotkeyMap
